module.exports = ".title-import .mat-tab-labels, .title-import .mat-tab-label, .title-import .mat-tab-link {\n  color: red;\n  font-weight: bolder; }\n"